/* eslint-disable react-refresh/only-export-components */

import { createFileRoute } from '@tanstack/react-router';
import { AuditsList } from '@/app/(client)/audits/-components/AuditsList';

export const Route = createFileRoute(
  '/(client)/audits/(pages)/(list)/network-audits/archive/',
)({
  component: ArchiveNetworkAuditsPage,
});

function ArchiveNetworkAuditsPage() {
  return <AuditsList activeTab='network-audits' isArchived={true} />;
}
